import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import Img from "gatsby-image"
import ArrowRight from "../../../images/arrow-right.svg"
import { useTranslateValue } from "../../../data/TranslateContext"

export default function MilkshakeVanillaBlissCup(props) {
  const images = useStaticQuery(graphql`
    query cupImageMilkshakeVanillaBlissCup {
      cupImageLarge: file(
        relativePath: { eq: "front-page-flavors/milkshake-vanilla-can.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 320) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageMedium: file(
        relativePath: { eq: "front-page-flavors/milkshake-vanilla-can.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 260) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageSmall: file(
        relativePath: { eq: "front-page-flavors/milkshake-vanilla-can.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 180) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const cupSources = [
    images.cupImageLarge.childImageSharp.fluid,
    {
      ...images.cupImageMedium.childImageSharp.fluid,
      media: `(max-width: 768px)`,
    },
    {
      ...images.cupImageSmall.childImageSharp.fluid,
      media: `(max-width: 540px)`,
    },
  ]

  const [{ language }] = useTranslateValue()

  return (
    <>
      <Img fluid={cupSources} />
      <div className="flavor-label">
        {language === "en" && <h2>Vanilla</h2>}
        {language === "fr" && <h2>Vanille</h2>}

        <Link to="/flavors" state={{ flavor: "milkshakeVanillaBliss" }}>
          {language === "en" && "Check out the details"}
          {language === "fr" && "Consultez les détails"}
          <ArrowRight />
        </Link>
      </div>
    </>
  )
}

const Svg = styled.svg`
  .active-bg-1 {
    transition: all 0.2s ease-in-out;
    opacity: ${props => (props.active ? 1 : 0)};
  }

  .border {
    transition: all 0.2s ease-in-out;
    fill: ${props => (props.active ? "#83311C" : props.theme.color.primary)};
  }
`
export function MilkshakeVanillaBlissThumb(props) {
  const { active } = props

  return (
    <>
      {/* Vanilla beans/flower */}
      <Svg
        version="1.1"
        viewBox="0 0 146 146"
        xmlns="http://www.w3.org/2000/svg"
        active={active}
      >
        <path
          className="active-bg-1"
          d="m63.7 58.61 0.55-1.27c4.84-11.34 10.72-18.85 14.32-18.34 3.5526 0.50329 7.0858 9.1772 8.6485 21.207l0.24145 1.873 1.4-0.08c12.14-0.71 21.38 1.2 22.5 4.6 1.0043 3.0129-3.6822 8.8761-11.969 15.003l-0.39107 0.28737-1.22 0.91 0.94 1.18 0.58826 0.76626c6.0724 8.0071 8.8454 14.766 7.0717 17.344-2.0026 2.9101-11.206 2.2683-22.466-1.5896l-1.7839-0.62035-0.55 1.28c-4.84 11.35-10.74 18.92-14.34 18.41-3.5526-0.50329-7.0858-9.1383-8.6485-21.09l-0.23145-1.8198-1.4 0.07c-12.12 0.62-20.98-1.26-22.12-4.66-1.0142-3.0228 3.6722-8.8861 11.959-15.003l1.6411-1.1969-0.95-1.22c-6.49-8.34-9.49-15.45-7.66-18.11 2.0121-2.9195 10.853-2.3174 22.09 1.4607l1.7796 0.60926zm13.01-3.34c-3.98-0.59-7.56 5.53-9.62 10l-0.77292-0.23717c-4.4842-1.3329-10.632-2.4023-12.747 0.66717-1.93 2.8 0.53 7.47 3.3 11.29-3.72 2.94-7.36 6.72-6.28 9.94 1.25 3.74 8.08 4.26 12.88 4.14l0.084755 0.53873c0.78478 4.8211 2.5407 11.202 6.3952 11.751l0.26 0.007468 0.26-0.007468c3.79 0 7.11-5.79 9.11-10.09l0.52422 0.16408c4.6154 1.4168 11.029 2.6441 13.206-0.52408 1.93-2.8-0.52-7.47-3.3-11.24l0.47415-0.37977c3.5479-2.8809 6.8499-6.4772 5.8158-9.5602-1.27-3.79-8.24-4.29-13.1-4.14l-0.077779-0.48305c-0.72887-4.3668-2.5769-11.268-6.4122-11.837zm-0.47358 2.9442 0.063578 0.0057963c1.0681 0.15396 3.0344 3.4469 4.001 10.271l0.10899 0.81913 0.18 1.39 1.39-0.07c7.32-0.44 11.11 0.91 11.47 2 0.29784 0.86471-1.0474 3.4279-5.8451 7.0334l-0.60485 0.44665-1.28 0.84 1 1.22 0.46406 0.61127c3.586 4.8075 4.1643 7.6303 3.6459 8.3887-0.63774 0.92226-4.5195 1.1803-11.192-1.077l-1.718-0.59303-0.55 1.29-0.32348 0.74339c-2.804 6.2993-5.598 8.8825-6.6765 8.7766-1.0989-0.10792-3.1122-3.508-4.0662-10.587l-0.053845-0.41252-0.17-1.38-1.39 0.07c-7.17 0.41-10.9-0.93-11.26-2-0.294-0.98 1.1023-3.5831 6.1184-7.2633l0.31164-0.22666 1.25-0.92-1-1.22c-4-5.18-4.79-8.07-4.11-9 0.66692-0.91212 4.4889-1.1798 11.041 1.0462l1.7086 0.58383 0.55-1.29c2.8561-6.6839 5.7797-9.5435 6.9364-9.4958z"
          fill="#FFEFBC"
        />
        <path
          className="border"
          d="m97.61 19.33c3 1.42 3.91 6.85 2.47 14.89-1.38 7.46-4.7 15.78-9.89 24.63l-0.03044 0.046508 0.19989-0.0073339c0.77733-0.028966 1.6246-0.050954 2.5215-0.059776 0.034765-0.059503 0.074847-0.11568 0.1191-0.1694 3.83-4.53 10.36-10.81 15.44-14l0.68344-0.42165c5.532-3.3415 9.8401-4.1815 11.887-2.2984l0.12631 0.12377 0.1315 0.1451c0.74469 0.87485 1.4357 2.6544-0.25781 5.8711-1.644 2.8937-3.8187 5.4516-6.41 7.54-0.39261 0.39307-0.97032 0.53695-1.5014 0.37392s-0.92861-0.60624-1.0331-1.1519c-0.10448-0.54565 0.10119-1.1044 0.53452-1.452 2.3194-1.8535 4.2699-4.1262 5.75-6.7 0.82-1.58 0.76-2.39 0.6-2.54-0.52-0.48-3.49-0.38-8.92 3.05-4.8469 3.3695-9.2823 7.2912-13.217 11.684l0.71983 0.031966 0.72566 0.039968c6.9162 0.41934 14.394 1.9914 15.962 6.6937 1.94 5.78-6.29 13.27-12.2 17.75l0.59496 0.80484 0.40306 0.5575c4.2519 5.9363 9.0376 14.408 5.832 19.068-4 5.84-18 2.17-25.07-0.17l-0.43754 0.96348-0.36938 0.79014c-3.0064 6.3486-9.0849 17.216-15.403 17.216-0.24961 0.019852-0.50039 0.019852-0.75 0-3.6403-0.5056-6.1942-4.6591-7.9499-9.4852-1.458 2.526-3.0859 5.4772-4.5124 8.0881l-1.5145 2.7755-1.5534 2.8176-0.22985 0.42394c-0.26677 0.47063-0.76908 0.75821-1.31 0.75064-0.25572 0-0.50733-0.064895-0.73-0.19064-0.69631-0.40538-0.94798-1.2884-0.57-2l2.14-3.89 0.73829-1.3795 1.1277-2.0779 0.68488-1.2459c1.5025-2.72 3.1071-5.5372 4.4491-7.7367 0.021632-0.054809 0.046271-0.10784 0.073685-0.15893-0.803-2.9339-1.355-5.8355-1.7142-8.0929l-1.2666 1.2632-1.0777 1.0644c-11.105 10.925-21.19 19.548-26.365 23.924-0.27392 0.23194-0.62107 0.35947-0.98 0.36042-0.63265 0.010276-1.204-0.37716-1.4281-0.96887-0.22413-0.59171-0.052865-1.2604 0.42811-1.6716l4.1701-3.5707 2.4859-2.1566 2.0787-1.8233c5.3759-4.7404 12.052-10.825 19.047-17.769l-1.0056-0.0052123-1.0405-0.017818c-7.5084-0.17597-17.194-1.4503-18.996-6.8573-1.93-5.78 6.29-13.27 12.2-17.75l-0.39515-0.53222-0.60287-0.83011c-4.2519-5.9363-9.0376-14.408-5.832-19.068 4-5.77 17.71-2.23 24.69 0l0.40195-0.87807 0.57849-1.2215c3.1788-6.5825 9.513-17.616 15.96-16.72 5.8267 0.80926 8.87 11.016 10.312 18.352 4.0282-7.4222 6.663-14.365 7.8081-20.672 1.37-7.57 0.24-11.17-0.8-11.65-0.46-0.22-1.54 0.28-2.91 1.89-2.2255 2.8363-3.8979 6.0657-4.93 9.52-0.27614 0.78148-1.1335 1.1911-1.915 0.915-0.73551-0.2599-1.1417-1.0347-0.95668-1.7764l0.041676-0.13856c1.1577-3.7932 3.0127-7.3371 5.47-10.45 3-3.56 5.36-3.2 6.49-2.66zm-33.166 37.558-0.74415 1.7215-1.31-0.45c-11.46-3.92-20.52-4.58-22.56-1.62-1.8018 2.6191 1.0788 9.5523 7.3629 17.726l1.2471 1.604-1.25 0.91c-8.53 6.22-13.38 12.22-12.35 15.29 1.14 3.4 10 5.28 22.12 4.66l1.4-0.1 0.17 1.37c1.53 12.2 5.11 21.06 8.71 21.57s9.5-7.06 14.34-18.41l0.55-1.28 1.32 0.46c11.47 4 20.9 4.7 22.93 1.75 1.83-2.66-1.18-9.77-7.66-18.11l-0.94-1.22 1.22-0.87c8.53-6.23 13.38-12.23 12.36-15.29-1.12-3.4-10.36-5.31-22.5-4.6l-1.4 0.08-0.18-1.39c-1.53-12.28-5.11-21.18-8.71-21.69-3.552-0.5032-9.3236 6.8012-14.126 17.888zm2.6459 8.3315 0.34955-0.74182c2.0908-4.3569 5.4035-9.8065 9.2705-9.2582 4.09 0.58 5.82 7.98 6.49 12.32l0.54829-0.013858c4.8202-0.094592 11.329 0.50423 12.552 4.1539 1.08 3.22-2.57 7.04-6.24 9.91l0.35279 0.49207c2.6278 3.722 4.7951 8.1171 2.9472 10.798-2.26 3.29-9.09 1.84-13.73 0.36l-0.23699 0.51232c-1.9466 4.1465-5.0997 9.36-8.6506 9.5711l-0.22244 0.006623c-0.17319 0.009957-0.34681 0.009957-0.52 0-4-0.57-5.79-7.42-6.53-12.31l-0.81749 0.013632c-4.7242 0.038652-10.882-0.62141-12.063-4.1536-1.08-3.22 2.56-7.04 6.28-9.94-2.77-3.82-5.23-8.49-3.3-11.29 2.24-3.25 8.95-1.86 13.52-0.43zm9.15-7.02c-1.1483-0.15704-3.9728 2.5758-6.8378 9.1157l-0.1622 0.37426-0.54 1.28-1.32-0.45c-6.79-2.33-10.85-1.97-11.39-1.14-0.51796 0.79612 0.058921 3.6163 3.6368 8.3812l0.4732 0.61884 1 1.22-1.25 0.92c-5.26 3.84-6.72 6.57-6.42 7.48 0.34588 0.96078 3.8026 2.2631 10.432 2.0356l0.82766-0.035629 1.45-0.02 0.17 1.38c0.93 7.31 2.96 10.86 4.12 11 1.117 0.13482 3.8661-2.4752 6.6756-8.7765l0.32436-0.74351 0.55-1.29 1.33 0.46c6.91 2.4 10.93 2.15 11.58 1.21 0.5184-0.7872-0.059904-3.6111-3.6459-8.3922l-0.46406-0.60782-1-1.22 1.22-0.89 0.6166-0.45547c4.7882-3.6008 6.1318-6.1617 5.8534-7.0545-0.34615-1.0192-3.8635-2.3066-10.641-2.0396l-0.82896 0.039614-1.47 0.08-0.18-1.39c-0.92-7.38-2.94-10.93-4.11-11.09z"
          fill="#83311C"
        />
      </Svg>
    </>
  )
}
